import { render } from "./AdminsTable.vue?vue&type=template&id=60e65e79&scoped=true"
import script from "./AdminsTable.vue?vue&type=script&lang=js"
export * from "./AdminsTable.vue?vue&type=script&lang=js"

import "./AdminsTable.vue?vue&type=style&index=0&id=60e65e79&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e65e79"]])

export default __exports__